module.exports = __webpack_public_path__ + "img/sujiyuding.ae013130.png";